import { Toaster } from "react-hot-toast";
import theme from "../../../config/theme";

export const ToasterContainer = () => (
  <Toaster
    position="bottom-right"
    containerStyle={{
      bottom: 72,
    }}
    toastOptions={{
      style: {
        borderRadius: "16px",
        padding: "14px 10px",
      },
      success: {
        style: {
          background: theme.colors.success,
          color: "#FFFFFF",
        },
      },
      error: {
        style: {
          background: theme.colors.error,
          color: "#FFFFFF",
        },
      },
    }}
  />
);
